<template>
  <b-modal id="global-confirm-modal"
           v-model="confirmState.visible"
           :title="confirmState.title"
           title-class="compact-modal-title"
           centered
           size="sm"
           hide-footer
           @hidden="onHidden">
    <div class="mb-4" v-if="confirmState.description">{{ confirmState.description }}</div>
    <div class="d-flex flex-row" style="gap: 8px">
      <b-button variant="themed"
                class="btn-themed btn-themed-squared btn-themed-outline btn-themed-squared-rounder w-100"
                :class="confirmState.cancelBtnClass"
                @click="onCancel">
        {{ confirmState.cancelTitle ? confirmState.cancelTitle : $t('cancel_verb') }}
      </b-button>
      <b-button variant="themed"
                class="btn-themed btn-themed-squared btn-themed-squared-rounder w-100"
                :class="confirmState.confirmBtnClass"
                @click="onConfirm">
        {{ confirmState.confirmTitle ? confirmState.confirmTitle : $t('confirm') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script setup>
import { confirmState } from "@/services/confirm.service"

const onConfirm = () => {
  confirmState.resolve?.(true)
  confirmState.resolve = null
  confirmState.visible = false
}

const onCancel = () => {
  confirmState.resolve?.(false)
  confirmState.visible = false
}

const onHidden = () => {
  if(confirmState.resolve) {
    confirmState.resolve?.(null)
  }
  confirmState.resolve = null
}
</script>
